export default __webpack_public_path__ + "static/media/file.41f0698e.svg";